import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  toggleShow,
  toggleState,
} from "../../sotre/redux/features/toggleMenuSlice";

import { getApi } from "../../services/api/globalApi";
import SidebarItem from "./sub-components/SidebarItem";
import { manufacturerSidBar, sidebarData } from "./sidebarData";
import { PiArrowSquareRightFill, PiSignOutBold } from "react-icons/pi";
import { useEffect, useState } from "react";
import { usersState } from "../../sotre/redux/features/userSlice";

export default function SideBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { users } = useSelector(usersState);
  const [sabooraAwaitingCount, setSabooraAwaitingCount] = useState(0);
  const [attarbashiAwaitingCount, setAttarbashiAwaitingCount] = useState(0);
  const [affiliateRequestPendingCount, setAffiliateRequestPendingCount] = useState(0);
  const [contactMessagePendingCount, setContactMessagePendingCount] = useState(0);
  const [experiencePendingCount, setExperiencePendingCount] = useState(0);
  const [reviewPendingCount, setReviewPendingCount] = useState(0);

  const fetchAwaitingCounts = async () => {
    try {
      const path = "admin/orders/awaiting-accepted-count";
      const [sabooraRes, attarbashiRes] = await Promise.all([
        getApi({ path, params: { brand: "saboora" } }),
        getApi({ path, params: { brand: "attarbashi" } }),
      ]);
      if (sabooraRes?.data?.result !== undefined) {
        setSabooraAwaitingCount(sabooraRes.data.result);
      }
      if (attarbashiRes?.data?.result !== undefined) {
        setAttarbashiAwaitingCount(attarbashiRes.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAffiliateRequestPendingCount = async () => {
    try {
      const res = await getApi({ path: "admin/affiliate-requests/pending-count" });
      if (res?.data?.result !== undefined) {
        setAffiliateRequestPendingCount(res.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchContactMessagePendingCount = async () => {
    try {
      const res = await getApi({ path: "admin/contact-messages/pending-count" });
      if (res?.data?.result !== undefined) {
        setContactMessagePendingCount(res.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchExperiencePendingCount = async () => {
    try {
      const res = await getApi({ path: "admin/customer-experiences/pending-count" });
      if (res?.data?.result?.count !== undefined) {
        setExperiencePendingCount(res.data.result.count);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchReviewPendingCount = async () => {
    try {
      const res = await getApi({ path: "admin/reviews/pending-count" });
      if (res?.data?.result?.count !== undefined) {
        setReviewPendingCount(res.data.result.count);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchReviewPendingCount();
    const interval = setInterval(fetchReviewPendingCount, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchExperiencePendingCount();
    const interval = setInterval(fetchExperiencePendingCount, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchAwaitingCounts();
    const interval = setInterval(fetchAwaitingCounts, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchContactMessagePendingCount();
    const interval = setInterval(fetchContactMessagePendingCount, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchAffiliateRequestPendingCount();
    const interval = setInterval(fetchAffiliateRequestPendingCount, 60000);
    return () => clearInterval(interval);
  }, []);

  const logOut = async () => {
    try {
      const path = "api/auth/logout";
      await getApi({ path });
      localStorage.removeItem("liResponse");
      navigate("/login");
    } catch (error) {
      console.log(error);
    }
  };

  const dispatch = useDispatch();

  const showMenu = useSelector(toggleState);

  const closeMenu = () => {
    dispatch(toggleShow());
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (showMenu && windowWidth < 1024) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showMenu, windowWidth]);

  return (
    <>
      {showMenu && (
        <div className="fixed w-screen h-screen z-[20] bg-black/30 backdrop-blur-sm lg:hidden"></div>
      )}
      <aside
        className={`fixed -right-[300px] top-0 z-[30] flex h-screen overflow-y-scroll w-[300px] lg:w-3/12 flex-col overflow-y-hidden bg-white/70 lg:bg-white/50 backdrop-blur-sm shadow-[0px_0px_25px_-5px_rgba(0,0,0,0.2)] dark:bg-[#060d26]/50 backdrop-blue-sm transition-all ease-linear lg:right-0 ${
          showMenu && "!right-0"
        }`}
      >
        <div className="flex flex-col items-center justify-between gap-2 px-6 pt-4 relative w-full">
          <img
            className="w-32 mx-auto"
            src={require("./../../assets/images/newLogo.png")}
            alt="Logo"
          />
          <PiArrowSquareRightFill
            onClick={closeMenu}
            size={44}
            className="absolute top-2 right-64 text-red-600 lg:hidden p-1  transition-all cursor-pointer hover:scale-110"
          />
        </div>
        <div className="flex w-full p-4">
          <ul className="flex flex-col items-start w-full">
            <li className="my-px w-full">
              <NavLink
                onClick={closeMenu}
                to="/"
                className={`${
                  ["/"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-gray-100 hover:bg-green-50 hover:text-green-600 dark:hover:bg-green-900/20 dark:hover:text-green-400"
                }`}
              >
                <span className="flex items-center justify-center text-lg">
                  <svg
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="h-6 w-6"
                  >
                    <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
                  </svg>
                </span>
                <span className="mx-3">داشبورد</span>
                {/* <span className="flex items-center justify-center text-sm text-gray-500 font-semibold bg-gray-300 h-6 px-2 rounded-full ml-auto">3</span> */}
              </NavLink>
            </li>
            <li className="my-px w-full">
              <span className="flex font-medium text-sm text-gray-400 px-4 my-4 uppercase">
                ابزار ها
              </span>
            </li>
            {users && users.mobile === "09301847909"
              ? manufacturerSidBar.map((item, index) => {
                  return (
                    <SidebarItem
                      key={index}
                      data={item}
                      closeMenu={closeMenu}
                      badgeCount={
                        item.name === "سفارشات صبورا"
                          ? sabooraAwaitingCount
                          : item.name === "سفارشات عطارباشی"
                          ? attarbashiAwaitingCount
                          : item.name === "نمایندگی"
                          ? affiliateRequestPendingCount
                          : 0
                      }
                    />
                  );
                })
              : sidebarData.map((item, index) => {
                  return (
                    <SidebarItem
                      key={index}
                      data={item}
                      closeMenu={closeMenu}
                      badgeCount={
                        item.name === "سفارشات صبورا"
                          ? sabooraAwaitingCount
                          : item.name === "سفارشات عطارباشی"
                          ? attarbashiAwaitingCount
                          : item.name === "نمایندگی"
                          ? affiliateRequestPendingCount
                          : item.name === "تماس با ما"
                          ? contactMessagePendingCount
                          : item.name === "تجربه مشتریان"
                          ? experiencePendingCount
                          : item.name === "نظرات و دیدگاه‌ها"
                          ? reviewPendingCount
                          : 0
                      }
                    />
                  );
                })}

            <li className="my-px cursor-pointer w-full" onClick={logOut}>
              <p className="flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-gray-100 hover:bg-green-50 hover:text-green-600 dark:hover:bg-green-900/20 dark:hover:text-green-400">
                <PiSignOutBold size={22} />
                <span className="mx-3">خروج</span>
              </p>
            </li>
          </ul>
        </div>
      </aside>
    </>
  );
}
